// extracted by mini-css-extract-plugin
export default {"inputContainer":"input_inputContainer__MUrCh","label":"input_label__nlpI7","input":"input_input__vuNkX","expandWidth":"input_expandWidth__VSqwZ"};